module.exports = __webpack_public_path__ + "img/validation-answer-positive.b50e93de.png";